/**
 * Format bytes to a human-readable string.
 * e.g., 15728640 -> "15.0 MB"
 */
export function formatBytes(bytes: number | null): string {
    if (bytes === null || bytes <= 0) return '0 B';

    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    const k = 1024;
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const value = bytes / Math.pow(k, i);

    return `${value.toFixed(1)} ${units[i]}`;
}
